import { cn } from "@utils";

const FormGroup = ({ children, className }) => {
  return (
    <div className={cn(
      "mb-8 relative", 
      className
    )}>
      {children}
    </div>
  );
};

export default FormGroup;

